// import { Star } from "lucide-react"
import { CiStar } from "react-icons/ci";

import { useEffect, useState } from "react"
// import '../css/reward.css'
export default function Rewards() {
  const [isLoading, setIsLoading] = useState(true)
  const [showConfetti, setShowConfetti] = useState(false)
  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false)
      setShowConfetti(true)
    }, 1000)
    // Reset confetti after animation
    const confettiTimer = setTimeout(() => {
      setShowConfetti(false)
    }, 5000)
    return () => {
      clearTimeout(timer)
      clearTimeout(confettiTimer)
    }
  }, [])
  if (isLoading) {
    return (
      <div className="loyalty-container loading">
        <div className="loading-content">
          <h1>Loading amazing rewards...</h1>
        </div>
      </div>
    )
  }
  return (
    <div className="loyalty-container">
      {showConfetti && (
        <div className="confetti-container">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="confetti"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                transform: `rotate(${Math.random() * 360}deg)`,
                width: `${Math.random() * 10 + 5}px`,
                height: `${Math.random() * 10 + 5}px`,
                backgroundColor: ["#FFD700", "#FF69B4", "#00BFFF", "#7CFC00", "#FF6347"][Math.floor(Math.random() * 5)],
                animationDelay: `${Math.random() * 2}s`,
              }}
            />
          ))}
        </div>
      )}
      <h1 className="loyalty-title">Customer Loyalty Program</h1>
      <div className="loyalty-content">
        <div className="left-section">
          <div className="company-logo">
            <img src="assets/img/logoDesign1.png" alt="NPCL Logo" />
          </div>
          <div className="trophy-container">
            <img
              src="assets/img/Picture1.png"
              style={{
                marginLeft: "57px",
                width:"110px",
                transition: "transform 0.3s ease",
              }}
              className="trophy-image"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.1)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)"
              }}
              alt="trophy"
            />
            <div className="coin coin-1">
              <div className="coin-inner"></div>
            </div>
            <div className="coin coin-2">
              <div className="coin-inner"></div>
            </div>
            <div className="coin coin-3">
              <div className="coin-inner"></div>
            </div>
          </div>
          <ul className="benefits-list">
            <li>
              <CiStar className="star-icon" fill="#FFD700" color="#FFD700" /> Opt for E-Bill
            </li>
            <li>
              <CiStar  className="star-icon" fill="#FFD700" color="#FFD700" /> Payment before due date
            </li>
            <li>
              <CiStar  className="star-icon" fill="#FFD700" color="#FFD700" /> Digital Payment for 12 months
            </li>
            <li>
              <CiStar  className="star-icon" fill="#FFD700" color="#FFD700" /> No Maintenance
            </li>
            <li>
              <CiStar  className="star-icon" fill="#FFD700" color="#FFD700" /> Unity Factor
            </li>
          </ul>
        </div>
        <div className="center-section">
          <div className="mic-badge">
            <img
              src="assets/img/Mic.png"
              style={{
                width: "94px",
                transition: "transform 0.3s ease",
              }}
              className="mic-image"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "rotate(10deg)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "rotate(0deg)"
              }}
              alt="microphone"
            />
          </div>
          <div className="register-container">
            <h2 className="register-text">REGISTER NOW</h2>
            <button
              className="offers-button"
              onClick={() => setShowConfetti(true)}
            >
              to avail exciting offers
            </button>
          </div>
          <div className="Wow2-badge">
            <img
              src="assets/img/Wow2.png"
              style={{
                width: "118px",
                transition: "transform 0.3s ease",
              }}
              className="wow2-image"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.1) rotate(5deg)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1) rotate(0deg)"
              }}
              alt="wow"
            />
          </div>
          <div className="shopping-badge">
            <img
              src="assets/img/Shopping.png"
              style={{
                width: "118px",
                transition: "transform 0.3s ease",
              }}
              className="shopping-image"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)"
              }}
              alt="shopping"
            />
          </div>
          <div className="wow-badge">
            <img
              src="assets/img/wow.png"
              style={{
                width: "118px",
                marginTop: "17px",
                transition: "transform 0.3s ease",
              }}
              className="wow-image"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.1) rotate(-5deg)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1) rotate(0deg)"
              }}
              alt="wow"
            />
          </div>
        </div>
        <div className="right-section">
          <div className="auth-buttons">
            <button className="login-button">Log in</button>
            <button className="register-button">Register</button>
          </div>
          <div className="gifts-container">
            <img
              src="assets/img/gift.png"  
              style={{
                marginRight: "50px",
                marginTop: "65px",
                width: "250px",
                transition: "transform 0.3s ease",
              }}
              className="gift-image"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)"
              }}
              alt="gift"
            />
          </div>
        </div>
      </div>
    </div>
  )
}